import SkeletonBox from '@/components/atoms/SkeletonBox/SkeletonBox';
import ContentBlock from '@/components/molecules/ContentBlock';

import styles from './cardParts.module.scss';

const TITLE_WIDTH = 160;
const TITLE_HEIGHT = 24;
const ROW_HEIGHT = 36;
const ROW_RADIUS = 4;
const ROW_KEYS = ['a', 'b', 'c', 'd'];

/**
 * Holds a module card's place while the cage context resolves.
 *
 * Until then the dashboard knows neither the pen's licences nor its bioscope type, so it cannot
 * tell whether the slot belongs to the welfare card (B/W) or the health card (colour) — only
 * that one of them is probably coming. Shaped like the health card's own skeleton.
 */
export default function ModuleCardSkeleton() {
    return (
        <ContentBlock spacing="none">
            <div className={styles.skeletonList} aria-hidden="true">
                <SkeletonBox width={TITLE_WIDTH} height={TITLE_HEIGHT} />
                {ROW_KEYS.map((key) => (
                    <SkeletonBox
                        key={key}
                        width="100%"
                        height={ROW_HEIGHT}
                        borderRadius={ROW_RADIUS}
                    />
                ))}
            </div>
        </ContentBlock>
    );
}
